var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#DADBEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.38184H8C5.79086 4.38184 4 6.1727 4 8.38184V16.3818C4 18.591 5.79086 20.3818 8 20.3818H16C18.2091 20.3818 20 18.591 20 16.3818V8.38184C20 6.1727 18.2091 4.38184 16 4.38184Z",
    stroke: "#424895",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 11.8778C15.2988 12.5436 15.1851 13.2236 14.8751 13.821C14.5651 14.4185 14.0746 14.903 13.4734 15.2056C12.8722 15.5082 12.1909 15.6135 11.5263 15.5066C10.8618 15.3996 10.2479 15.0859 9.77198 14.61C9.29604 14.134 8.98229 13.5201 8.87536 12.8556C8.76843 12.1911 8.87376 11.5097 9.17637 10.9085C9.47898 10.3073 9.96346 9.81683 10.5609 9.50683C11.1583 9.19683 11.8383 9.0831 12.5041 9.18183C13.1832 9.28254 13.812 9.599 14.2975 10.0845C14.7829 10.57 15.0994 11.1987 15.2001 11.8778Z",
    stroke: "#424895",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3999 7.98181H16.4079",
    stroke: "#424895",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.08bc341d317f81d8bd92f5274862d297.svg";
export { ForwardRef as ReactComponent };